var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynergiAIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28714_719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4737 32H2V41.5C2 46.7472 6.24105 51 11.4737 51C14.5716 51 17.3253 49.5085 19.0526 47.2C14.4516 43.7325 11.4737 38.2162 11.4737 32Z",
    fill: "#F34D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3389 47.5198C33.2789 45.0562 31.1536 41.4747 30.5789 37.3928C30.5252 37.3928 30.4747 37.3833 30.421 37.3833C24.241 37.3833 19.2105 32.342 19.2105 26.1417C19.2105 19.9413 24.241 14.9 30.421 14.9H38.6884C36.1905 13.684 33.3863 13 30.421 13H11.4736V32C16.7063 32 20.9473 36.2528 20.9473 41.5C20.9473 43.6375 20.2431 45.6135 19.0526 47.2C22.2199 49.5845 26.1547 51 30.421 51C32.9599 51 35.1736 49.594 36.3389 47.5198Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6318 26.1418C23.6318 29.8975 26.6792 32.9502 30.4213 32.9502V19.3335C26.6792 19.3335 23.6318 22.3893 23.6318 26.1418Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9473 41.5C20.9473 36.2528 16.7063 32 11.4736 32C11.4736 38.2162 14.4515 43.7325 19.0526 47.2C20.2431 45.6135 20.9473 43.6375 20.9473 41.5Z",
    fill: "#F35F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2111 19.3335H44.5406C47.5406 22.6965 49.369 27.133 49.369 32.0002C49.369 38.5362 46.0753 44.3027 41.0637 47.7227C40.8237 48.4447 40.5142 49.1382 40.1416 49.7873C42.0111 50.5695 44.0605 51.0033 46.2142 51.0033C54.9332 51.0033 62.0037 43.9132 62.0037 35.17C62.0037 26.4268 54.9332 19.3367 46.2142 19.3367L46.2111 19.3335Z",
    fill: "#F3A521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5791 37.3926C31.1507 41.4744 33.2759 45.0591 36.3391 47.5196C36.8917 46.5347 37.2107 45.4011 37.2107 44.1914C37.2107 40.4896 34.2486 37.4781 30.5791 37.3926Z",
    fill: "#F38221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4209 32.9502C36.6009 32.9502 41.6314 37.9915 41.6314 44.1918C41.6314 45.4237 41.4293 46.6112 41.063 47.7227C46.0746 44.3027 49.3683 38.5393 49.3683 32.0002C49.3683 27.133 47.5398 22.6965 44.5398 19.3335H30.4209V32.9502Z",
    fill: "#F38221"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28714_719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38,
    fill: "white",
    transform: "translate(2 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynergiAIcon);
export default __webpack_public_path__ + "static/media/SynergiA_icon.40795c039e25de60bd164b84b91f9bae.svg";
export { ForwardRef as ReactComponent };